<script setup lang="ts">
import BaseDialog from "@/stories/dialogs/BaseDialog.vue";
import { onClickOutside } from "@vueuse/core";
import { ref } from "vue";

export type DialogSizes = "xs" | "sm" | "base" | "md" | "lg";

interface Props {
  size?: DialogSizes;
  customClass?: string;
  alignTop?: boolean;
}

withDefaults(defineProps<Props>(), {
  size: "md",
  alignTop: false,
});

const emit = defineEmits<{ close: []; clickOutside: [] }>();

const contentRef = ref<HTMLElement | undefined>();

const WIDTH_MAP: Record<DialogSizes, string> = {
  xs: "desktop:w-[30rem]",
  sm: "desktop:w-[31.25rem]",
  base: "desktop:w-[37.5rem]",
  md: "desktop:w-[62.5rem]",
  lg: "desktop:w-[87.5rem]",
};

onClickOutside(contentRef, () => {
  emit("clickOutside");
});
</script>

<template>
  <BaseDialog
    @on-close="$emit('close')"
    :customDialogClass="alignTop ? 'laptop:mt-[7.5rem] laptop:mb-0' : ''"
  >
    <div
      ref="contentRef"
      :class="[
        'bg-white overflow-hidden flex flex-col justify-between w-full',
        'fixed top-0 left-0 h-dvh',
        alignTop
          ? 'laptop:static laptop:left-auto laptop:h-auto laptop:max-h-[calc(100dvh-15rem)] laptop:w-[52rem]'
          : 'laptop:static laptop:left-auto laptop:h-auto laptop:max-h-[80dvh] laptop:w-[52rem]',
        customClass ? customClass : WIDTH_MAP[size],
      ]"
    >
      <slot></slot>
    </div>
  </BaseDialog>
</template>
